<template>
  <div class="guider-apply-container">
    <div class="pc">
      <hm-content title>
        <div class>
          <div class="table-panel flex flex-end flex-wrap mb20 mt20">
            <el-date-picker
              v-model="searchCondition.date"
              type="daterange"
              align="right"
              start-placeholder="加入开始日期"
              end-placeholder="加入结束日期"
              value-format="yyyy-MM-dd"
              size="small"
              class="mr10"
            ></el-date-picker>
            <el-select
              size="small"
              clearable
              placeholder="选择城市"
              v-model="city"
              class="mr10"
              style="width: 200px"
              filterable
            >
              <el-option
                v-for="(item, i) in storeList"
                :key="i"
                :label="item.name"
                :value="item.objectId"
              ></el-option>
            </el-select>
            <el-input
              clearable
              v-model.trim="searchCondition.keywords"
              placeholder="输入门店名/导购姓名/电话号码"
              size="small"
              style="width: 222px"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div>
          <div class="table">
            <el-table
              stripe
              border
              ref="brandTable"
              @selection-change="getChecked"
              :data="list"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                fixed
                type="selection"
                width="40"
                v-if="tabPosition !== '全部'"
              ></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="审核状态"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="导购姓名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="身份证号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="电话号码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="所在省"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="所在市"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="所属门店商"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="所属门店"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="申请时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="申请加入渠道商"
              ></el-table-column>
              <!-- 已审核已驳回不显示 -->
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="text"
                    @click="viewDetails(scope.row)"
                    >导购信息</el-button
                  >
                  <el-button size="small" type="text" @click="audit(scope.row)"
                    >同意</el-button
                  >
                  <el-button size="small" type="text" @click="reject(scope.row)"
                    >驳回</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="total"
                @current-change="paging"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <el-dialog
          title="导购信息"
          :close-on-click-modal="false"
          :visible.sync="detailsDialogVisible"
          custom-class="sales-volumn-dialog"
        >
          <el-table
            stripe
            border
            ref="brandTable"
            class="mb20"
            :data="list"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="导购姓名"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="电话"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="身份证号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="所属门店商"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="所属门店"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="门店地址"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="已加入渠道商"
            ></el-table-column>
          </el-table>
          <div class="flex mb20">
            <div class="title mr10">工牌照片</div>
            <div>
              <el-image
                style="width: 100px; height: 100px"
                class="mr10"
                src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                :preview-src-list="srcList"
              ></el-image>
            </div>
          </div>
          <div class="flex">
            <div class="title mr10">门店门头照片</div>
            <div>
              <el-image
                style="width: 100px; height: 100px"
                class="mr10"
                src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                :preview-src-list="srcList"
              ></el-image>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          title="驳回备注"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          custom-class="sales-volumn-dialog"
        >
          <el-form label-width="80px">
            <el-form-item label="驳回原因">
              <el-input
                maxlength="100"
                placeholder="请输入驳回原因，可直接选择下方模板"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="reason"
              ></el-input>
            </el-form-item>
            <div class="reject-reason">
              <el-radio-group
                v-model="rejectReason"
                @change="switchRejectReason"
              >
                <div v-for="(v, i) in rejectTemp" :key="i">
                  <el-radio :label="i">{{ v }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button @click="submitRuleForm" size="small" type="primary"
              >保存</el-button
            >
            <el-button @click="dialogVisible = false" size="small"
              >关闭</el-button
            >
          </span>
        </el-dialog>
      </hm-content>
    </div>
    <div class="mobile">
      <div class="tabs flex flex-between">
        <div
          @click="switchTab(i)"
          class="tab"
          :class="{ active: activeTab === i }"
          v-for="(v, i) in tabList"
          :key="i"
        >
          {{ v.name }}
        </div>
      </div>
      <div class="scroll-content">
        <div class="control-panel flex">
          <div class="ipt-wrapper flex-1 flex item-center">
            <span class="icon hmicon icon-search"></span>
            <form @submit="search">
              <input
                type="search"
                ref="ipt"
                class="flex-1"
                placeholder="请输入导购名称/电话"
                v-model="keywords"
              />
            </form>
          </div>
          <el-date-picker
            v-model="searchCondition.date"
            type="daterange"
            align="right"
            start-placeholder="申报开始时间"
            end-placeholder="申报结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
        </div>
        <ul class="list">
          <li
            v-infinite-scroll="load"
            class="list-item"
            @click="toDetails(v)"
            v-for="(v, i) in mobileList"
            :key="i"
          >
            <div class="flex flex-between item-center">
              <div class="flex item-center">
                <div class="tag">导购信息</div>
                <div class="user-info flex-1">
                  <span class="mr10">{{ v.guideName }}</span>
                  <span>{{ v.mobile }}</span>
                </div>
              </div>
            </div>
            <div class="info">
              <div>
                加入渠道商：
                <span class="merchant">{{ v.merchant }}</span>
              </div>
              <div>
                <span class="date gray">申报日期：{{ v.date }}</span>
              </div>
            </div>
          </li>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      city: "",
      status: "",
      detailsDialogVisible: false,
      storeList: [
        {
          city: "武汉市"
        }
      ],
      auditState: "agreen",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg"
      ],
      rejectReason: "",
      reason: "",
      dialogVisible: false,
      isOutputing: false,
      list: [
        {
          orderSn: "6125615514",
          income: 548,
          status: "audit_pass"
        }
      ],
      searchCondition: {},
      total: 10,
      currentPage: 1,
      pageSize: 10,
      rejectTemp: [],
      tabPosition: "all",
      activeTab: 0,
      // 移动端data
      keywords: "",
      tabList: [
        {
          name: "待审核"
        },
        {
          name: "已审核"
        },
        {
          name: "已驳回"
        }
      ],
      loading: false,
      noMore: false,
      mobileList: [
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryList();
  },
  methods: {
    viewDetails() {
      this.detailsDialogVisible = true;
    },
    switchRejectReason() {
      this.reason = this.rejectTemp[this.rejectReason];
    },
    reject() {
      this.dialogVisible = true;
    },
    output() {},
    search() {
      this.queryList();
    },
    queryList() {},
    switchTab() {},
    getChecked() {},
    async audit(row) {
      const result = await this.$confirm(`是否同意销量申报？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
      }
    },
    submitRuleForm() {},
    handleCurrentChange() {},
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    load() {},
    toDetails(v) {
      this.$router.push({ name: "GuiderApplyDetails" });
    }
  }
};
</script>
<style lang="scss">
.sales-volumn-dialog {
  width: 800px;
}
@media screen and (max-width: 600px) {
  .sales-volumn-dialog {
    width: 320px;
  }
}
.reject-reason {
  .el-radio__label {
    white-space: normal;
    line-height: 24px;
  }
}
</style>
<style lang="scss" scoped>
.income {
  color: #e50065;
}
.title {
  width: 85px;
  text-align: right;
}

@media screen and (max-width: 414px) {
  .guider-apply-container {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      margin: -10px;
      font-size: 14px;
      .list {
        background: #fff;
        .price {
          font-size: 16px;
        }
        .list-item {
          padding: 15px 15px 15px 0;
          margin-left: 15px;
          border-bottom: 1px solid #efefef;
          color: #999;
          line-height: 25px;
        }
        .count {
          color: #589dff;
        }
        .price {
          color: #f72b2b;
        }
        .tag {
          background: linear-gradient(
            -86deg,
            rgba(247, 173, 74, 1),
            rgba(255, 128, 128, 1)
          );
          color: #fff;
          font-size: 10px;
          border-radius: 30px;
          padding: 0 5px;
          margin-right: 5px;
        }
        .user-info {
          margin-right: 5px;
          color: #2b2b2b;
        }
      }
      .merchant {
        color: #005ceb;
      }
      .tabs {
        background: #fff;
        padding: 15px;
        margin-bottom: 10px;
        .tab {
          position: relative;
          &.active:after {
            content: "";
            position: absolute;
            bottom: -17px;
            left: 50%;
            width: 50%;
            transform: translateX(-50%);
            border-bottom: 4px solid #005ceb;
            border-radius: 30px;
          }
        }
      }

      .scroll-content {
        padding-bottom: 20px;
      }

      .control-panel {
        background: #fff;
        padding: 15px;
        border-bottom: 1px solid #f5f5f5;
        .ipt-wrapper {
          background: #f0f0f0;
          height: 34px;
          line-height: 34px;
          border-radius: 30px;
          border-bottom: 1px solid #f5f5f5;
          margin-right: 5px;
          padding-left: 10px;
          input {
            height: 34px;
            border: none;
            background: transparent;
            padding-left: 5px;
            font-size: 14px;
            &:focus {
              outline: none;
            }
          }
        }
      }

      .info {
        margin-top: 10px;
        line-height: 25px;
      }
    }
  }
}
@media screen and (min-width: 415px) {
  .guider-apply-container {
    .pc {
      display: block;
    }

    .mobile {
      display: none;
    }
  }
}
</style>
